module.exports = __webpack_public_path__ + "img/send-call-success.d3376f32.svg";